export default __webpack_public_path__ + "static/media/women.73078e63.jpg";